import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function XLM({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M17.348 6.969l-1.8.918-8.699 4.43a5.182 5.182 0 017.663-5.193l1.031-.525.154-.08a6.33 6.33 0 00-10.028 5.605 1.15 1.15 0 01-.626 1.113l-.544.277v1.293l1.6-.816.519-.264.51-.26 9.17-4.673 1.03-.524 2.13-1.086V5.892zm2.111 1.509L7.651 14.49l-1.03.525L4.5 16.097v1.293l2.106-1.073 1.8-.918 8.708-4.437a5.182 5.182 0 01-7.671 5.198l-.064.033-1.118.57a6.33 6.33 0 0010.03-5.606 1.15 1.15 0 01.624-1.112l.544-.278z" /><path  d="M17.368 7.327l-1.8.918-8.698 4.43a5.182 5.182 0 017.663-5.193l1.03-.525.154-.08A6.33 6.33 0 005.69 12.483a1.15 1.15 0 01-.625 1.113l-.544.277v1.293l1.6-.816.519-.264.51-.26 9.17-4.673 1.03-.524 2.13-1.086V6.25zm2.112 1.51l-11.809 6.01-1.03.525-2.12 1.082v1.293l2.106-1.073 1.8-.918 8.708-4.437a5.182 5.182 0 01-7.672 5.198l-.064.033-1.117.57a6.33 6.33 0 0010.029-5.606 1.15 1.15 0 01.625-1.112l.544-.278z" /></Svg>;
}
XLM.DefaultColor = DefaultColor;
export default XLM;